import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import {
	Button,
	ButtonGroup,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';
import $ from 'jquery';

class QuestionPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: new Array(2).fill(false),
			dropdownOpen1: new Array(2).fill(false),
			dropdownOpen2: new Array(2).fill(false),
			dropdownOpen3: new Array(2).fill(false),
			dropdownOpen4: new Array(2).fill(false),
			dropdownOpen5: new Array(2).fill(false),
		}
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.toggle3 = this.toggle3.bind(this);
		this.toggle4 = this.toggle4.bind(this);
		this.toggle5 = this.toggle5.bind(this);
	}
	toggle(i) {
		const newArray = this.state.dropdownOpen.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen: newArray
		});
	}
	toggle1(i) {
		const newArray = this.state.dropdownOpen1.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen1: newArray
		});
	}
	toggle2(i) {
		const newArray = this.state.dropdownOpen2.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen2: newArray
		});
	}
	toggle3(i) {
		const newArray = this.state.dropdownOpen3.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen3: newArray
		});
	}
	toggle4(i) {
		const newArray = this.state.dropdownOpen4.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen4: newArray
		});
	}
	toggle5(i) {
		const newArray = this.state.dropdownOpen5.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen5: newArray
		});
	}

	render() {

	let userData = JSON.parse(sessionStorage.getItem('userData'));
	this.state.userId = userData['userid'];
	this.state.userRole = userData['userrole'];

		return (
			<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
				<a className="navbar-brand" href="javascript:;"><i className="fa fa-question"></i>&nbsp; Question Bank</a>
				<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					<ul className="navbar-nav mr-auto">
						<li className="nav-item dropdown">
							<ButtonDropdown isOpen={this.state.dropdownOpen[0]} toggle={() => { this.toggle(0); }}>
								<DropdownToggle caret color="class">
									Settings
								</DropdownToggle>
								<DropdownMenu>
									<Link to="/books" className="dropdown-item" >Books</Link>
									<Link to="/lesson" className="dropdown-item" >Lesson</Link>
								</DropdownMenu>
							</ButtonDropdown>
						</li>
						<li className="nav-item active">
							<Link to="/questions/list" className="dropdown-item">Question Bank</Link>
						</li>
						<li className="nav-item active">
							<Link to="/questions/setup" className="dropdown-item">Question Setup </Link>
						</li>
						<li className="nav-item dropdown">
							<ButtonDropdown isOpen={this.state.dropdownOpen1[0]} toggle={() => { this.toggle1(0); }}>
								<DropdownToggle caret color="class">
									Conduct Exam
								</DropdownToggle>
								<DropdownMenu>
									<Link to="/questions/examsetup" className="dropdown-item">Exam Setup </Link>
									<Link to="/questions/examresult" className="dropdown-item" >Exam Result</Link>
								</DropdownMenu>
							</ButtonDropdown>
						</li>
						{this.state.userRole == 'admin' ?
						<React.Fragment>
						<li className="nav-item active">
							<Link to="/questions/demoexam" className="dropdown-item">Demo Exam </Link>
						</li>
						</React.Fragment> : ''}
					</ul>
				</div>
			</nav>
		)
	}
}

export default QuestionPage;


// WEBPACK FOOTER //
// ./src/views/QuestionPage/QuestionPage.js